import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme/index.js';
import { Headline } from './styled.js';

var _templateObject;
var StyledLabel = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  padding-left: ", ";\n  cursor: pointer;\n  user-select: none;\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  span {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    background-color: ", ";\n    border: ", ";\n  }\n\n  /* When the checkbox is checked, add a blue background */\n  input:checked ~ span {\n    background-color: ", ";\n    border: none;\n  }\n\n  /* Create the checkmark/indicator (hidden when not checked) */\n  span:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n\n  /* Show the checkmark when checked */\n  input:checked ~ span:after {\n    display: block;\n  }\n\n  /* Style the checkmark/indicator */\n  span:after {\n    left: 9px;\n    top: 5px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n  }\n  ", " {\n    margin: 0;\n  }\n"])), function (props) {
  return props.hasLabel ? "33px" : 0;
}, function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? Theme.colors.dangerLight : "transparent";
}, function (_ref2) {
  var hasError = _ref2.hasError,
    darker = _ref2.darker;
  return hasError ? "1px solid ".concat(Theme.colors.danger) : "1px solid ".concat(darker ? Theme.colors.darkerLtGrey : Theme.colors.darkgrey);
}, Theme.colors.lightBlue, Headline);
var Checkbox = function Checkbox(_ref3) {
  var field = _ref3.field,
    id = _ref3.id,
    label = _ref3.label,
    errors = _ref3.errors,
    touched = _ref3.touched,
    darker = _ref3.darker,
    fontSize = _ref3.fontSize;
  var name = field.name,
    value = field.value,
    onChange = field.onChange,
    onBlur = field.onBlur;
  var hasError = errors[name] && touched[name];
  return /*#__PURE__*/React__default.createElement(StyledLabel, {
    hasError: hasError,
    hasLabel: label,
    darker: darker
  }, /*#__PURE__*/React__default.createElement("input", {
    name: name,
    id: id,
    type: "checkbox",
    value: value,
    checked: value,
    onChange: onChange,
    onBlur: onBlur
  }), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement(Headline, {
    as: "label",
    htmlFor: id,
    fontSize: fontSize
  }, label));
};
Checkbox.defaultProps = {
  field: {},
  errors: {},
  touched: {}
};
Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  errors: PropTypes.object,
  touched: PropTypes.object,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
  }).isRequired
};

export { StyledLabel, Checkbox as default };
